import { User, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface CreationLogValue {
  createdBy: string;
  createdAt: string | number;
  avatar?: string;
}

interface CreationLogCellProps {
  value: CreationLogValue | null;
  readOnly?: boolean;
}

export function CreationLogCell({ value }: CreationLogCellProps) {
  // Creation Log é sempre read-only
  
  if (!value) {
    return <span className="text-gray-400 text-sm">-</span>;
  }

  const { createdBy, createdAt, avatar } = value;
  
  let timeAgo = '';
  try {
    const date = typeof createdAt === 'number' ? new Date(createdAt) : new Date(createdAt);
    if (!isNaN(date.getTime())) {
      timeAgo = formatDistanceToNow(date, { addSuffix: true, locale: ptBR });
    } else {
      timeAgo = 'data inválida';
    }
  } catch (e) {
    timeAgo = 'data inválida';
  }

  return (
    <div className="flex items-center gap-2">
      {avatar ? (
        <img src={avatar} alt={createdBy} className="w-6 h-6 rounded-full" />
      ) : (
        <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
          <User className="w-4 h-4 text-blue-600" />
        </div>
      )}
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-700">{createdBy}</span>
        <div className="flex items-center gap-1 text-xs text-gray-500">
          <Clock className="w-3 h-3" />
          <span>{timeAgo}</span>
        </div>
      </div>
    </div>
  );
}
